"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var itemStyles = (0, _styledComponents.css)(["", ";", " color:", ";cursor:pointer;display:block;font-weight:normal;padding:", " ", ";text-decoration:none;[data-pka-anchor=\"icon\"]{padding:5px;}&:focus{box-shadow:", ";outline:none;position:relative;", "}", " &:hover{", "}&:active{", "}"], _stylers["default"].fontSize(), _stylers["default"].lineHeight(), _tokens["default"].color.black, _tokens["default"].spaceSm, _stylers["default"].spacer(2), _tokens["default"].highlight.active.withBorder.insetBoxShadow, _stylers["default"].z(1), function (_ref) {
  var isDestructive = _ref.isDestructive,
      isDisabled = _ref.isDisabled;
  var colorString;

  if (isDisabled) {
    colorString = isDestructive ? "orangeDisabled" : "blackDisabled";
    return {
      color: _tokens["default"].color[colorString]
    };
  }

  colorString = isDestructive ? "orangeDarken10" : "colorBlack";
  return {
    color: _tokens["default"].color[colorString]
  };
}, function (_ref2) {
  var isDestructive = _ref2.isDestructive,
      isDisabled = _ref2.isDisabled;

  if (!isDisabled) {
    var bgColorString = isDestructive ? "orangeLighten40" : "blackLighten70";
    return {
      backgroundColor: _tokens["default"].color[bgColorString]
    };
  }
}, function (_ref3) {
  var isDestructive = _ref3.isDestructive,
      isDisabled = _ref3.isDisabled;

  if (!isDisabled) {
    var bgColorString = isDestructive ? "orangeLighten40" : "blackLighten60";
    return {
      backgroundColor: _tokens["default"].color[bgColorString]
    };
  }
});
var _default = itemStyles;
exports["default"] = _default;
//# sourceMappingURL=Item.styles.js.map